import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Controls from "../../components/controls/Controls";
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import Layout from "../../components/layout/Layout";
import { TableBody, TableRow, TableCell, Typography } from "@material-ui/core";
import { Grid, Toolbar, InputAdornment } from "@material-ui/core";
import { useEffect, useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../components/customHelpers/useTable";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import Admin from "../../components/auth/Admin";
import Order from "../../actions/order";
import { FiEdit, FiEye } from "react-icons/fi";

import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { Box, Paper, TextField } from "@mui/material";
import { useLocation } from "react-router-dom";

const headCells = [
  { id: "id", label: "Id" },
  { id: "assignTo", label: "Assigned To" },
  { id: "totalPrice", label: "Total Price" },
  { id: "paid", label: "Paid" },
  { id: "unpaid", label: "Balance" },
  { id: "createdAt", label: "Date" },
  { id: "status", label: "Status" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const CustomerOrderPage = () => {
  let location = useLocation();
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewCustomerOrders } = Order();
  const value = location.pathname.split("/").filter((x) => x)[
    location.pathname.split("/").filter((x) => x).length - 1
  ];

  const [totals, setTotals] = useState({
    totalPaid: 0,
    totalUnpaid: 0,
  });

  const [orders, setOrders] = useState([]);

  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  useEffect(() => {
    getAllOrders();
  }, [reload]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const [additionalConfirmDialog, setAdditionalConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    onConfirm: () => {},
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const getAllOrders = () => {
    setValues({ ...values, loading: true });
    viewCustomerOrders(value).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.orders) {
        setValues({
          ...values,
          loading: false,
        });
        const filteredOrders = data.orders.filter(
          (order) => order.status !== "Pending"
        );

        setOrders(filteredOrders);
        let totalPaid = 0;
        let totalUnpaid = 0;

        filteredOrders.forEach((order) => {
          const orderPaid = parseFloat(order.paid) || 0;
          const totalOrderPrice =
            order.orderProducts?.reduce(
              (sum, product) => sum + (parseFloat(product.totalPrice) || 0),
              0
            ) || 0;

          totalPaid += orderPaid;
          totalUnpaid += totalOrderPrice - orderPaid;
        });

        setTotals({
          totalPaid: totalPaid.toFixed(2),
          totalUnpaid: totalUnpaid.toFixed(2),
        });
      }
    });
  };

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(orders, headCells, filterFn);

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["status", "customer", "id"];

        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  const calculateTotalPrice = (data) => {
    let totalPrice = 0;
    if (data.length > 0) {
      data.forEach((order) => {
        totalPrice += parseFloat(order.totalPrice);
      });
      return totalPrice.toFixed(2); // Return the total price rounded to 2 decimal places
    }
  };

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography
            variant="h6"
            style={{ marginBottom: "0px" }}
            className="page-header"
          >
            <ArrowBackIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                history.push("/customers");
              }}
            ></ArrowBackIcon>{" "}
            <span style={{ marginLeft: "6px" }}>Customer Orders</span>
          </Typography>{" "}
          <Toolbar>
            <Controls.Input
              label="Search Orders"
              className="searchInput"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />
          </Toolbar>
          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{`${item.id.slice(0, 7)}--`}</TableCell>
                            <TableCell>{item.staff?.fullName}</TableCell>
                            <TableCell>
                              {item?.orderProducts?.length > 0
                                ? calculateTotalPrice(item.orderProducts)
                                : 0}
                            </TableCell>
                            <TableCell>{item.paid}</TableCell>
                            <TableCell>
                              {calculateTotalPrice(item.orderProducts) -
                                item.paid}
                            </TableCell>
                            <TableCell>
                              {new Date(item.createdAt).toLocaleString()}
                            </TableCell>
                            <TableCell>{item.status}</TableCell>
                            <TableCell>
                              <Controls.ActionButton
                                color="primary"
                                title="View Detail"
                                onClick={() => {
                                  history.push(`/print/${item.id}`);
                                }}
                              >
                                <FiEye fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </Paper>
              )}
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              flexDirection: "column",
              p: 1,
              m: 1,
              bgcolor: "background.paper",
              borderRadius: 1,
            }}
          >
            <Box p={1}>
              <span style={{ marginRight: "10px" }}>Total Paid</span>
              <TextField value={totals.totalPaid} variant="outlined" disabled />
            </Box>

            <Box p={1}>
              <span style={{ marginRight: "10px" }}>Total Balance</span>
              <TextField
                value={totals.totalUnpaid}
                variant="outlined"
                disabled
              />
            </Box>
          </Box>
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <ConfirmDialog
            confirmDialog={additionalConfirmDialog}
            setConfirmDialog={setAdditionalConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
      </Admin>
    </Layout>
  );
};

export default CustomerOrderPage;
